import { render } from "./ExtendDialog.vue?vue&type=template&id=6715dbf0"
import script from "./ExtendDialog.vue?vue&type=script&lang=js"
export * from "./ExtendDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__